import { Route, Routes } from "react-router-dom";

import React from "react";
import Account from "./Account";
import Subscriptions from "./Subscriptions";
import SubscriptionRefresh from "../components/SubscriptionStates/SubscriptionRefresh";

export const AccountRoutes = () => {
  return (
    <Routes>
      <Route path="home" element={<Account />} />
      <Route path="subscriptions" element={<Subscriptions />} />
      <Route path="subscriptions/refresh" element={<SubscriptionRefresh />} />
    </Routes>
  );
};
